import { render, staticRenderFns } from "./job_app.vue?vue&type=template&id=f70a54ea&"
import script from "./job_app.vue?vue&type=script&lang=js&"
export * from "./job_app.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "job_app.vue"
export default component.exports